import { Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { lastValueFrom, Subject, Subscription } from "rxjs";
import { AuthService } from "src/app/services/auth.service";
import { BaseServiceService } from "src/app/services/base-service.service";
import { AppData } from "../../helpers/app-data";

declare var fabric: any;

@Component({
  selector: "app-usernav-log",
  templateUrl: "./usernav-log.component.html",
  styleUrl: "./usernav-log.component.scss",
})
export class UsernavLogComponent implements OnInit, OnDestroy {
  modalNotifyLogout: any;
  username: string | null = null;
  private usernameSubscription: Subscription | null = null;

  constructor(
    private authservice: AuthService,
    private baseService: BaseServiceService,
    private router: Router
  ) {}
  notificationsCount: number;
  notificationsMenuOpen: boolean = false;
  pendientes;
  retrasadas;
  notifications: { text: string }[];

  async ngOnInit() {
    var ContextualMenuElements = document.querySelectorAll(
      ".ms-ContextualMenuExample"
    );
    for (var i = 0; i < ContextualMenuElements.length; i++) {
      var ButtonElement = ContextualMenuElements[i].querySelector(".ms-Button");
      var ContextualMenuElement =
        ContextualMenuElements[i].querySelector(".ms-ContextualMenu");
      new fabric["ContextualMenu"](ContextualMenuElement, ButtonElement);
    }
    this.usernameSubscription = this.baseService.currentUsername.subscribe(
      (username) => {
        this.username = username;
      }
    );

    this.actualizarDatosNotificaciones();


    setInterval(() => {
      this.actualizarDatosNotificaciones();
    }, AppData.tiempo_refresh_Notificaciones);
  }

  async actualizarDatosNotificaciones() {
    var ContextualMenuElements = document.querySelectorAll(
      ".ms-ContextualMenuExample"
    );
    for (var i = 0; i < ContextualMenuElements.length; i++) {
      var ButtonElement = ContextualMenuElements[i].querySelector(".ms-Button");
      var ContextualMenuElement =
        ContextualMenuElements[i].querySelector(".ms-ContextualMenu");
      new fabric["ContextualMenu"](ContextualMenuElement, ButtonElement);
    }
  
    this.usernameSubscription = this.baseService.currentUsername.subscribe(
      (username) => {
        this.username = username;
      }
    );
  
    try {
      let notificaciones = await lastValueFrom(
        this.baseService.getAll("EjecucionTarea/GetEstadoCounts")
      );
      if (notificaciones.Ok) {
        this.notificationsCount = notificaciones.Data.TotalEjecuciones;
        this.pendientes = notificaciones.Data.Pendiente;
        this.retrasadas = notificaciones.Data.Retrasadas;
        this.notifications = [
          { text: `Tareas Pendientes: ${this.pendientes}` },
          { text: `Tareas Retrasadas: ${this.retrasadas}` },
        ];
      }
    } catch (error) {
      console.error("Error al obtener notificaciones:", error);
    }
  }


  ngOnDestroy() {
    if (this.usernameSubscription) {
      this.usernameSubscription.unsubscribe();
    }
  }

  confirmLogOut() {
    const dialog = document.querySelector(".logout-modal");
    this.modalNotifyLogout = new fabric["Dialog"](dialog);

    this.modalNotifyLogout.open();
  }

  onLogOut() {
    this.authservice.logout();
  }

  close() {
    this.modalNotifyLogout.close();
  }

  toggleNotificationsMenu() {
    this.notificationsMenuOpen = !this.notificationsMenuOpen;
  }
  navigateToTareas(){
    this.router.navigate(['home/tareas']);
  }
}
